const MARC_TYPES = {
  BIB: 'bibliographic',
  HOLDINGS: 'holdings',
};

export default MARC_TYPES;
